var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52012 4.50933C2.55553 6.47143 1.33215 9.05408 1.05846 11.8171C0.784768 14.5802 1.47771 17.3527 3.01919 19.6621C4.56067 21.9714 6.85529 23.6748 9.51199 24.4819C12.1687 25.2889 15.0231 25.1498 17.5886 24.088C20.1542 23.0263 22.2722 21.1077 23.5817 18.6593C24.8911 16.2109 25.311 13.3842 24.7698 10.6609C24.2286 7.93754 22.7597 5.48617 20.6135 3.72454C18.4673 1.9629 15.7767 1.00002 13.0001 1V11.2853",
    stroke: "#B3B3B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.10890d81e8d52dc0b3acc318e9b91c0c.svg";
export { ForwardRef as ReactComponent };